import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader, Modal } from '@mantine/core';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import TextField from '../../fields/Text';
import { useDispatch, useSelector } from 'react-redux';
import icEmail from '../../../assets/ic-email.svg';
import { requestForgotPassword } from '../../../pages/ResetPassword/actions';
import IconWarning from '../../icons/IconWarning';

const ModalForgotPassword = ({ onClose, open }) => {
  const emailFieldProps = {
    placeholder: 'Contoh format email:  Fulan@gmail.com',
    label: 'Email',
    icon: icEmail,
    clearable: true,
  };

  const dispatch = useDispatch();
  const { isLoading, message, code } = useSelector(
    (state) => state.resetPassword
  );
  const [email, setEmail] = useState('');
  const [meta, setMeta] = useState({ touched: false, error: '' });

  const handleChange = ({ target }) => {
    setEmail(target.value);
    const touched = true;
    const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
      target.value
    );
    if (!isEmail) setMeta({ touched, error: 'Format penulisan email salah' });
    if (!target.value) setMeta({ touched, error: 'Email harus diisi' });
    if (isEmail && target.value) setMeta({ touched, error: '' });
  };

  const handleReset = () => {
    setMeta({ touched: false, error: '' });
    setEmail('');
  };

  const handleCancel = () => {
    handleReset();
    onClose(false);
  };

  const handleClear = () => {
    setEmail('');
    setMeta({ touched: true, error: 'Email harus diisi' });
  };

  const handleSubmit = () => {
    dispatch(requestForgotPassword(email));
  };

  useEffect(() => {
    if (!isLoading && message && !message.includes('5 menit') && code !== 200) {
      setMeta({ touched: true, error: message });
    } else if (!isLoading && message && code === 200) {
      onClose(false);
    }
  }, [isLoading, message]);

  return (
    <Modal centered onClose={handleCancel} opened={open} size="lg">
      <div className={styles.contentModal}>
        <h4>Lupa Kata Sandi?</h4>
        <hr className={styles.line} />
        <p>
          Masukkan email Anda yang terdaftar untuk dapatkan tautan unik
          pembaruan kata sandi
        </p>
      </div>
      <TextField
        errorIcon={
          <IconWarning className={styles['error-icon']} color="#CF212A" />
        }
        input={{ value: email }}
        inputProps={{
          ...emailFieldProps,
          onChange: handleChange,
          onClear: handleClear,
        }}
        meta={meta}
      />

      <div className={styles.modalAction}>
        <Button onClick={handleCancel} style={'outlined'} type="button">
          Batal
        </Button>
        <Button
          disabled={meta.error || !email || isLoading}
          onClick={handleSubmit}
          style={'blue'}
          type="button"
        >
          <span>Lanjutkan</span>
          {isLoading ? <Loader ml="xs" size="xs" /> : null}
        </Button>
      </div>
    </Modal>
  );
};

export default ModalForgotPassword;

ModalForgotPassword.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
